import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import LinkIcon from '@mui/icons-material/Link';
import {
    GridActionsCellItem,
    GridColDef,
    GridRowId,
    GridRowParams,
} from '@mui/x-data-grid';

import {
    ACTIONS_WIDTH,
    ACTIVE_WIDTH,
    ID_WIDTH,
    NAME_MIN_WIDTH,
    TYPE_WIDTH,
} from '@barboxx/admin-utils';
import { BusinessLocker } from '@barboxx/models';

import { isProduction } from '../../../../../../../config/constants';
import { CancelRelateAction, EditSaveAction } from './TableActions';

// Generated by Copilot

const HIDDEN_SECRET = '••••••••';

type Columns = GridColDef<BusinessLocker>[];

const BASE_COLUMNS: Columns = [
    { field: 'id', headerName: 'Id', width: ID_WIDTH },
    {
        field: 'name',
        headerName: 'Name',
        minWidth: NAME_MIN_WIDTH,
        flex: 1,
        editable: true,
    },
    {
        field: 'numberOfCubbies',
        headerName: '# of Units',
        align: 'right',
        headerAlign: 'right',
        width: TYPE_WIDTH,
        editable: true,
    },
    {
        field: 'nfcPassword',
        headerName: 'NFC Password',
        minWidth: 180,
        flex: 1,
        editable: true,
        valueFormatter: value => (value ? HIDDEN_SECRET : ''),
    },
    {
        field: 'nfcSecret',
        headerName: 'NFC Secret',
        minWidth: 220,
        flex: 1,
        editable: true,
        valueFormatter: value => (value ? HIDDEN_SECRET : ''),
    },
    {
        field: 'hasCameras',
        headerName: 'Cameras',
        headerAlign: 'center',
        align: 'center',
        width: 100,
        type: 'boolean',
        editable: true,
    },
    {
        field: 'active',
        headerName: 'Active',
        width: ACTIVE_WIDTH,
        headerAlign: 'center',
        align: 'center',
        type: 'boolean',
        editable: true,
    },
    {
        field: 'online',
        headerName: 'Online',
        headerAlign: 'center',
        align: 'center',
        width: ACTIVE_WIDTH,
        type: 'boolean',
        editable: !isProduction,
    },
];

interface BuildLockerColumnsParams {
    isInternalUser: boolean;
    isRowInEditMode: (id: GridRowId) => boolean;
    onGenerateNfcCredentials: (id: GridRowId) => void;
    onOpenNfcUrlList: (locker: BusinessLocker) => void;
    onDelete: () => void;
}

export const buildLockerColumns = ({
    isInternalUser,
    isRowInEditMode,
    onGenerateNfcCredentials,
    onOpenNfcUrlList,
    onDelete,
}: BuildLockerColumnsParams): Columns => {
    const visibleColumns = isInternalUser
        ? BASE_COLUMNS
        : BASE_COLUMNS.filter(
              column =>
                  !['nfcPassword', 'nfcSecret'].includes(String(column.field))
          );

    return [
        ...visibleColumns,
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: ACTIONS_WIDTH + 90,
            cellClassName: 'actions',
            display: 'flex',
            align: 'right',
            getActions: (params: GridRowParams<BusinessLocker>) => {
                const isInEditMode = isRowInEditMode(params.id);

                return [
                    <EditSaveAction key="editSave" {...params} />,
                    ...(isInternalUser && !isInEditMode
                        ? [
                              <GridActionsCellItem
                                  key="nfcUrls"
                                  icon={<LinkIcon />}
                                  label="View NFC URLs"
                                  onClick={() => onOpenNfcUrlList(params.row)}
                                  color="inherit"
                              />,
                          ]
                        : []),
                    ...(isInternalUser && isInEditMode
                        ? [
                              <GridActionsCellItem
                                  key="generateNfcCredentials"
                                  icon={<AutoFixHighIcon />}
                                  label="Generate NFC Credentials"
                                  onClick={() =>
                                      onGenerateNfcCredentials(params.id)
                                  }
                                  color="inherit"
                              />,
                          ]
                        : []),
                    <CancelRelateAction
                        key="cancelRelate"
                        {...params}
                        onDelete={onDelete}
                    />,
                ];
            },
        },
    ];
};
